import type { Column } from '@tanstack/react-table';
import type { CSSProperties } from 'react';
import { mergeColumnStyles } from '../helpers/utils';

type TableColgroupProps<TData> = {
  columns: Column<TData, unknown>[];
  columnStyles: Record<string, CSSProperties | undefined>;
  weightedLeafWidthStyles: Record<string, CSSProperties>;
};

/**
 * テーブルのcolgroup要素をレンダリングするコンポーネント
 */
export const TableColgroup = <TData,>({
  columns,
  columnStyles,
  weightedLeafWidthStyles,
}: TableColgroupProps<TData>) => {
  return (
    <colgroup>
      {columns.map((column) => {
        const style = columnStyles[column.id];
        const weightedStyle = weightedLeafWidthStyles[column.id];
        const mergedStyle = mergeColumnStyles(style, weightedStyle);
        return (
          // table-layout: fixed でも列幅を安定させるため、<col>に幅を適用する
          <col key={column.id} style={mergedStyle} />
        );
      })}
    </colgroup>
  );
};
